// Setores nas telas de Faturamento 12m e Margem por setor (Plano de ação › Ciclo 1).
// LUGAR ÚNICO de rótulo, cor e ordem. O servidor devolve só CHAVES (a DRE usa
// chaves curtas: consultoria, fiscalizacao, segbarr; o resto do ERP usa as
// canônicas) — aqui as duas viram uma só.
//
// Regra de gráfico: a cor de um setor depende da CHAVE, nunca da posição na
// lista. Se um setor some do período, os outros não trocam de cor.
import { SETORES } from '../pages/financeiro-contas-receber/utils';

export const CHAVE_CURTA_PARA_CANONICA: Record<string, string> = {
  topografia: 'topografia',
  hidrometria: 'hidrometria',
  projeto: 'projeto',
  consultoria: 'consultoria_ambiental',
  fiscalizacao: 'fiscalizacao_projeto',
  segbarr: 'seguranca_barragem',
};

export const CHAVE_FRENTE_TOPO_HIDRO = 'topografia_hidrometria';
export const CHAVE_SEM_SETOR = 'sem_setor';

export interface MetaSetor { chave: string; rotulo: string; cor: string; ordem: number }

const COR_SEM_SETOR = '#d9d9d9';
const COR_DESCONHECIDO = '#8c8c8c';

/** Chave curta da DRE (ou canônica) → chave canônica. Desconhecida volta como veio. */
export function chaveCanonica(chave: string): string {
  return CHAVE_CURTA_PARA_CANONICA[chave] || chave;
}

function capitalizar(t: string): string {
  const s = t.replace(/_/g, ' ');
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function metaSetor(chaveBruta: string): MetaSetor {
  const chave = chaveCanonica(chaveBruta);
  if (chave === CHAVE_SEM_SETOR) {
    // Mesmo rótulo da Receita bruta da DRE (utils/areasReceita.ts).
    return { chave, rotulo: 'Sem setor (classificar)', cor: COR_SEM_SETOR, ordem: 99 };
  }
  if (chave === CHAVE_FRENTE_TOPO_HIDRO) {
    return { chave, rotulo: 'Topografia e Hidrometria', cor: SETORES.topografia.cor, ordem: SETORES.topografia.ordem };
  }
  const s = SETORES[chave];
  if (s) return { chave, rotulo: s.rotulo, cor: s.cor, ordem: s.ordem };
  return { chave, rotulo: capitalizar(chave), cor: COR_DESCONHECIDO, ordem: 50 };
}

/** Ordem fixa do cadastro; "sem setor" sempre por último. Não repete chave. */
export function ordenarSetores(chaves: string[]): string[] {
  const vistos = new Set<string>();
  const lista: MetaSetor[] = [];
  for (const c of chaves) {
    const m = metaSetor(c);
    if (vistos.has(m.chave)) continue;
    vistos.add(m.chave);
    lista.push(m);
  }
  lista.sort((a, b) => a.ordem - b.ordem || a.rotulo.localeCompare(b.rotulo, 'pt-BR'));
  return lista.map((m) => m.chave);
}
